const navBarVisible = () => {
	const navbar = document.querySelector('.nav-bar')
	navbar.classList.toggle('nav-bar_open')
}
const init = () => {
	const burger = document.querySelector('.header__burger')
	if(burger) {
		burger.addEventListener('click', () => navBarVisible())
	}
}

export default {
	init,
};
